import React from 'react';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import EditProfileForm from '../../components/EditProfileForm';

import s from './EditProfile.css';

const EditProfile = () => {

  const initialValues = useSelector(state => state?.account?.data);

  return (
    <EditProfileForm initialValues={initialValues} />
  );
}

export default withStyles(s)(EditProfile);
